var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProductHuntReviewsScraper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".white{fill:#fff;}.reddit{fill:url(#reddit-gradient);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "reddit-gradient",
    x1: 4.44048,
    y1: 0.88619,
    x2: 81.05694,
    y2: 83.47983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fe8166"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48367,
    stopColor: "#ff6154"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c93d54"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "reddit",
    d: "M78.17747,88.61091c-18.78499,2.12302-37.56996,2.12302-56.35494,0-5.49081-.62055-9.8129-4.94264-10.43345-10.43345-2.12301-18.78497-2.12301-37.56995,0-56.35493.62055-5.49081,4.94265-9.8129,10.43346-10.43345,18.78498-2.12301,37.56995-2.12301,56.35494,0,5.49081.62055,9.8129,4.94264,10.43346,10.43345,2.12301,18.78497,2.12301,37.56995,0,56.35492-.62055,5.49081-4.94265,9.8129-10.43345,10.43345Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "white",
    d: "M68.7511,41.36249c-.92926-8.05933-7.68726-13.92889-15.81616-13.98315-6.78857-.04535-13.57782.00995-20.36646-.02924-1.09351-.00629-1.44202.32562-1.43494,1.43787.0451,7.07928.02295,14.159.02307,21.23853.00012,7.11609.01495,14.23218-.01746,21.34808-.00433.9541.29834,1.29175,1.25305,1.27148,2.26196-.04797,4.52661-.05426,6.78815.00262,1.05396.02649,1.39276-.3562,1.37915-1.39911-.04816-3.68512.00372-7.37146-.0343-11.05682-.00897-.86981.28528-1.13025,1.13898-1.12225,3.86859.03632,7.73822-.02344,11.60657.0238,8.32953.10168,16.67975-7.32922,15.48035-17.73181ZM57.80768,42.38885l-3.06073,3.31696.52643,4.48242c.11505.97937-.88629,1.70703-1.78217,1.29492l-4.10046-1.88593-4.1004,1.88593c-.89581.41211-1.89728-.31555-1.78223-1.29492l.52655-4.48242-3.06073-3.31696c-.6687-.72467-.28613-1.90186.68085-2.09509l4.42572-.88446,2.2088-3.93591c.48254-.85992,1.72034-.85992,2.203,0l2.2088,3.93591,4.42572.88446c.96698.19324,1.34955,1.37042.68085,2.09509Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductHuntReviewsScraper);
export default __webpack_public_path__ + "static/media/product-hunt-reviews-scraper.a5203c5f362775ecd355059363ad0bd5.svg";
export { ForwardRef as ReactComponent };